export default function Cards() {
  return (
    <section id="cards" className="w-full py-14 md:py-18 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between mb-8 gap-3">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              热播推荐
            </h2>
            <p className="text-foreground-600 text-sm mt-2">全网热门影视，高清即点即播</p>
          </div>
          <a
            href="#ranking"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看热播榜单 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer">
            <div className="aspect-[16/9] w-full overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20scene%20with%20giant%20planet%20engines%20and%20space%20atmosphere%2C%20cinematic%20warm%20golden%20lighting%2C%20epic%20scale%2C%20dramatic%20composition&width=640&height=360&seq=card-movie-01&orientation=landscape"
                alt="流浪地球3"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-4">
              <span className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded whitespace-nowrap">科幻 · 2026 · 4K</span>
              <h3 className="font-heading text-base font-bold text-foreground-900 mt-2 mb-1">流浪地球3</h3>
              <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">太阳急速老化，人类面临前所未有的生存危机，全球联合政府启动"流浪地球"计划的最终篇章。</p>
            </div>
          </div>

          <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer">
            <div className="aspect-[16/9] w-full overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20elegant%20Korean%20drama%20aesthetic%20with%20soft%20dramatic%20lighting%2C%20moody%20atmosphere%2C%20warm%20dark%20tones%2C%20cinematic%20composition%2C%20subtle%20suspense%20feeling&width=640&height=360&seq=card-movie-02&orientation=landscape"
                alt="黑暗荣耀 第二季"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-4">
              <span className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded whitespace-nowrap">剧情 · 韩剧 · 全8集</span>
              <h3 className="font-heading text-base font-bold text-foreground-900 mt-2 mb-1">黑暗荣耀 第二季</h3>
              <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">文东恩精心策划的复仇计划进入最高潮，所有棋子各归其位，真相即将大白于天下。</p>
            </div>
          </div>

          <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer">
            <div className="aspect-[16/9] w-full overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythology%20fantasy%20scene%20with%20ancient%20warriors%20and%20magical%20elements%2C%20dramatic%20golden%20and%20crimson%20lighting%2C%20cinematic%20grand%20scale%20composition&width=640&height=360&seq=card-movie-03&orientation=landscape"
                alt="封神第二部"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-4">
              <span className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded whitespace-nowrap">奇幻 · 2026 · 高清</span>
              <h3 className="font-heading text-base font-bold text-foreground-900 mt-2 mb-1">封神第二部</h3>
              <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">姜子牙率众神讨伐纣王，封神大战全面爆发，仙魔对决震撼银幕，神话史诗再续传奇。</p>
            </div>
          </div>

          <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer">
            <div className="aspect-[16/9] w-full overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20cinematic%20scene%20with%20warm%20dramatic%20lighting%2C%20traditional%20Japanese%20aesthetic%20elements%2C%20dark%20rich%20tones%2C%20artistic%20composition&width=640&height=360&seq=card-movie-04&orientation=landscape"
                alt="鬼灭之刃 最终季"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-4">
              <span className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded whitespace-nowrap">动画 · 日漫 · 全11集</span>
              <h3 className="font-heading text-base font-bold text-foreground-900 mt-2 mb-1">鬼灭之刃 最终季</h3>
              <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">炭治郎与伙伴们迎来最终决战，面对鬼舞辻无惨，赌上一切的终极之战正式开启。</p>
            </div>
          </div>

          <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer">
            <div className="aspect-[16/9] w-full overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Moody%20suspense%20thriller%20atmosphere%20with%20warm%20nostalgic%20lighting%2C%20autumn%20tones%2C%20Chinese%20small%20town%20setting%2C%20cinematic%20mystery%20aesthetic%2C%20soft%20film%20grain%20texture&width=640&height=360&seq=card-movie-05&orientation=landscape"
                alt="漫长的季节"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-4">
              <span className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded whitespace-nowrap">悬疑 · 国产 · 12集全</span>
              <h3 className="font-heading text-base font-bold text-foreground-900 mt-2 mb-1">漫长的季节</h3>
              <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">一桩跨越二十年的悬案，三个家庭的命运交织，真相在时光中逐渐浮出水面，扣人心弦。</p>
            </div>
          </div>

          <div className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer">
            <div className="aspect-[16/9] w-full overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20portrait%20atmosphere%20with%20warm%20amber%20and%20sepia%20tones%2C%20historical%20scientific%20aesthetic%2C%20intense%20mood%2C%20artistic%20film%20poster%20style%20composition&width=640&height=360&seq=card-movie-06&orientation=landscape"
                alt="奥本海默"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
            </div>
            <div className="p-4">
              <span className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded whitespace-nowrap">传记 · 获奖 · 4K修复</span>
              <h3 className="font-heading text-base font-bold text-foreground-900 mt-2 mb-1">奥本海默</h3>
              <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">诺兰执导奥斯卡获奖巨制，讲述"原子弹之父"奥本海默的传奇人生与内心挣扎，震撼人心。</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}